// Label common
export const BACK = "ld.common.back";
export const CERCA = "ld.common.cerca";
export const BACK_HOME = "ld.common.backHome";
export const APRI = "ld.common.apri";
export const CHIUDI = "ld.common.chiudi";
export const NO_DATA = "ld.common.noData";
export const CLEAR = "ld.common.clear";
export const YES_LABEL = "ld.common.yes";
export const NO_LABEL = "ld.common.no";
export const INFO_LABEL = "ld.common.info";
export const HOME_LABEL = "ld.common.home";

// Label welcome page
export const WELCOME_TITLE = "ld.welcome.welcomeTitle";
export const WELCOME_INFO = "ld.welcome.welcomeInfo";
export const WELCOME_INFO_2 = "ld.welcome.welcomeInfo2";
export const WELCOME_INFO_3 = "ld.welcome.welcomeInfo3";
export const NEXT = "ld.welcome.next";
export const ENTER = "ld.welcome.enter";

// Label per il drawer installazione iOS
export const INSTALLATION_DRAWER_SUBHEADER = "ld.iosInstallationDrawer.subheader";
export const INSTALLATION_DRAWER_INFO = "ld.iosInstallationDrawer.info";
export const INSTALLATION_DRAWER_SHARE_INSTRUCTIONS = "ld.iosInstallationDrawer.shareInstructions";
export const INSTALLATION_DRAWER_SHARE_LABEL = "ld.iosInstallationDrawer.shareLabel";
export const INSTALLATION_DRAWER_ADD_TO_HOME_INSTRUCTIONS = "ld.iosInstallationDrawer.addToHomeInstructions";
export const INSTALLATION_DRAWER_ADD_TO_DOCK_INSTRUCTIONS = "ld.iosInstallationDrawer.addToDockInstructions";
export const INSTALLATION_DRAWER_ADD_TO_HOME_LABEL = "ld.iosInstallationDrawer.addToHomeLabel";
export const INSTALLATION_DRAWER_ADD_TO_DOCK_LABEL = "ld.iosInstallationDrawer.addToDockLabel";

// Label per la pagina home
export const HOME_INFO = "ld.home.info";
export const PRONTO_SOCCORSO_PLACEHOLDER = "ld.home.prontoSoccorso";
export const CODICE_ACCESSO_PLACEHOLDER = "ld.home.codiceAccesso";
export const REQUIRED_FIELD = "ld.home.campoObbligatorio";
export const CODICE_ACCESSO_ERROR = "ld.home.codiceAccessoError";
export const CODICE_ACCESSO_ERROR_2 = "ld.home.codiceAccessoError2";
export const CODICE_ACCESSO_EXPIRED = "ld.home.codiceAccessoExpired";
export const CODICE_ACCESSO_EXPIRED_DESCRIPTION = "ld.home.codiceAccessoExpiredDescription";
export const PS_FUORI_SERVIZIO = "ld.home.psFuoriServizio";
export const PS_FUORI_SERVIZIO_DESCRIPTION = "ld.homepsFuoriServizioDescription";
export const INSTALLA_APP_REQUEST = "ld.home.installaAppRequest";
export const INSTALLA_APP_INFO = "ld.home.installaAppInfo";
export const INSTALLA_APP_BUTTON = "ld.home.installaAppButton";
export const NOTIFICHE_NEGATE_ALERT = "ld.home.notificheNegateAlert";

// Label per la pagina di monitoraggio
export const NOTIFICATION_ACTIVE = "ld.monitoraggio.notificheAttive";
export const NOTIFICATION_ACTIVE_ARIA_LABEL = "ld.monitoraggio.notificheAttiveAriaLabel";
export const NOTIFICATION_UNACTIVE = "ld.monitoraggio.notificheDisattive";
export const NOTIFICATION_UNACTIVE_ARIA_LABEL = "ld.monitoraggio.notificheDisattiveAriaLabel";
export const ENCOUNTER_OSPEDALE_CHANGED = "ld.monitoraggio.updateEncounterNotification.ospedale";
export const ENCOUNTER_LUOGO_CHANGED = "ld.monitoraggio.updateEncounterNotification.luogo";
export const ENCOUNTER_STATO_CHANGED = "ld.monitoraggio.updateEncounterNotification.stato";
export const ENCOUNTER_COLORE_CHANGED = "ld.monitoraggio.updateEncounterNotification.codiceColore";
export const ENCOUNTER_PRESTAZIONI_CHANGED = "ld.monitoraggio.updateEncounterNotification.prestazioni";
export const MESSAGGIO_RASSICURANTE = "ld.monitoraggio.messaggioRassicurante";
export const LAST_UPDATE = "ld.monitoraggio.lastUpdate";
export const UPDATE_PRESTAZIONE = "ld.monitoraggio.updatePrestazione";
export const GOOGLE_MAPS_MODAL = "ld.monitoraggio.mapsModal";
export const NAVIGA = "ld.monitoraggio.naviga";
export const CODICE_EMERGENZA = "ld.monitoraggio.codiceEmergenza";
export const CODICE_EMERGENZA_BIANCO = "ld.monitoraggio.codiceEmergenza.bianco";
export const CODICE_EMERGENZA_VERDE = "ld.monitoraggio.codiceEmergenza.verde";
export const CODICE_EMERGENZA_AZZURRO = "ld.monitoraggio.codiceEmergenza.azzurro";
export const CODICE_EMERGENZA_ARANCIONE = "ld.monitoraggio.codiceEmergenza.arancione";
export const CODICE_EMERGENZA_ROSSO = "ld.monitoraggio.codiceEmergenza.rosso";
export const STATO_PAZIENTE = "ld.monitoraggio.statoPaziente";
export const PRONTO_SOCCORSO = "ld.monitoraggio.prontoSoccorso";
export const ACCESSO_PS = "ld.monitoraggio.accessoProntoSoccorso";
export const POSIZIONE = "ld.monitoraggio.posizione";
export const PRESTAZIONI_LABEL = "ld.monitoraggio.prestazioni";
export const EMPTY_MESSAGE = "ld.monitoraggio.empty";
export const EVENT_COMPLETED_LABEL = "ld.monitoraggio.eventCompleted";
export const FOLLOW_UP_REQUEST = "ld.monitoraggio.followUp";

// Label per il footer
export const FOOTER_PRIVACY_POLICY = "ld.footer.privacyPolicy";
export const FOOTER_COOKIE_POLICY = "ld.footer.cookiePolicy";
export const FOOTER_ACCESSIBILITA = "ld.footer.accessibility";
export const FOOTER_COLORI_TRIAGE = "ld.footer.coloriTriage";
export const FOOTER_FAQ = "ld.footer.faq";
export const FOOTER_CONTATTI = "ld.footer.contatti";

// Label per la pagina di errore
export const LOADING_CONFIG_ERROR = "ld.errorPage.loadingConfigError";
export const LOADING_PS_ERROR = "ld.errorPage.loadingPsError";
export const RETRY = "ld.errorPage.retry";

// Label per la pagina not found
export const NOT_FOUND_ERROR = "ld.notFoundPage.notFoundError";
export const NOT_FOUND_TITLE = "ld.notFoundPage.notFoundTitle";
export const NOT_FOUND_DESCRIPTION = "ld.notFoundPage.notFoundDescription";

// Label per i sagas
export const SAGAS_CONFIG_ERROR_TITLE = "ld.sagas.configErrorTitle";
export const SAGAS_CONFIG_ERROR_DESCRIPTION = "ld.sagas.configErrorDescription";
export const SAGAS_ELENCO_OSPEDALI_ERROR_TITLE = "ld.sagas.elencoPsErrorTitle";
export const SAGAS_ELENCO_OSPEDALI_ERROR_DESCRIPTION = "ld.sagas.elencoPsErrorDescription";
export const SAGAS_CODICI_COLORE_ERROR_TITLE = "ld.sagas.codiciColoreErrorTitle";
export const SAGAS_CODICI_COLORE_ERROR_DESCRIPTION = "ld.sagas.codiciColoreErrorDescription";
export const SAGAS_FAQ_ERROR_TITLE = "ld.sagas.faqErrorTitle";
export const SAGAS_FAQ_ERROR_DESCRIPTION = "ld.sagas.faqErrorDescription";
export const SAGAS_COOKIE_POLICY_ERROR_TITLE = "ld.sagas.cookiePolicyErrorTitle";
export const SAGAS_COOKIE_POLICY_ERROR_DESCRIPTION = "ld.sagas.cookiePolicyErrorDescription";
export const SAGAS_CONTACTS_ERROR_TITLE = "ld.sagas.contactsErrorTitle";
export const SAGAS_CONTACTS_ERROR_DESCRIPTION = "ld.sagas.contactsErrorDescription";
export const SAGAS_PRIVACY_PS_ERROR_TITLE = "ld.sagas.privacyPsErrorTitle";
export const SAGAS_PRIVACY_PS_ERROR_DESCRIPTION = "ld.sagas.privacyPsErrorDescription";
export const SAGAS_INIZIO_MONITORAGGIO_ERROR_TITLE = "ld.sagas.inizioMonitoraggioErrorTitle";
export const SAGAS_INIZIO_MONITORAGGIO_ERROR_DESCRIPTION = "ld.sagas.inizioMonitoraggioErrorDescription";
export const SAGAS_SERVER_ERROR_TITLE = "ld.sagas.serverErrorTitle";
export const SAGAS_SERVER_ERROR_DESCRIPTION = "ld.sagas.serverErrorDescription";
export const TOO_MANY_REQUEST_ERROR_TITLE = "ld.sagas.tooManyRequestErrorTitle";
export const TOO_MANY_REQUEST_ERROR_DESCRIPTION = "ld.sagas.tooManyRequestErrorDescription";
export const SAGAS_CHECK_SUBSCRIPTION_ERROR_TITLE = "ld.sagas.checkSubscriptionErrorTitle";
export const SAGAS_CHECK_SUBSCRIPTION_ERROR_DESCRIPTION = "ld.sagas.checkSubscriptionErrorDescription";
export const SAGAS_SUBSCRIPTION_ERROR_TITLE = "ld.sagas.subscriptionErrorTitle";
export const SAGAS_SUBSCRIPTION_ERROR_DESCRIPTION = "ld.sagas.subscriptionErrorDescription";
export const SAGAS_UNSUBSCRIPTION_ERROR_TITLE = "ld.sagas.unsubscriptionErrorTitle";
export const SAGAS_UNSUBSCRIPTION_ERROR_DESCRIPTION = "ld.sagas.unsubscriptionErrorDescription";
